import { useState, useEffect } from 'react';

export const useDebouncedClick = (callback, delay) => {
  const [isDebounced, setIsDebounced] = useState(false);

  const handleClick = (...args) => {
    if (!isDebounced) {
      callback(...args);
      setIsDebounced(true);
    }
  };

  useEffect(() => {
    if (isDebounced) {
      const timer = setTimeout(() => {
        setIsDebounced(false);
      }, delay);

      // Cleanup the timer
      return () => clearTimeout(timer);
    }
    // Return a no-op cleanup function to satisfy the consistent-return rule
    return () => {};
  }, [isDebounced, delay]);

  return [handleClick, isDebounced];
};
